export const ATUALIZADO = 'Produto atualizado'
export const CADASTRADO = 'Produto adicionado'
export const NAO_ENCONTRADO = 'Não foram encontrados produtos cadastrados'
export const NAO_ENCONTRADO_FILTRO = 'Não há produtos com esse filtro'
